import React from 'react'
import PropTypes from 'prop-types'
import { useRef, useState, useEffect } from 'react'
import translator from 'src/translate'
//redux
import { useDispatch, useSelector } from 'react-redux'
import { courseGetSuccess } from 'src/reducers/course/action'
import { clearCardState } from 'src/reducers/card/action'
import { useSnackbar } from 'notistack'
// @mui
import { Stack, MenuItem, Tooltip, Select, Divider } from '@material-ui/core'
// components
import MenuPopover from 'src/components/MenuPopover'
import ShareLinkStep from 'src/pages/create-mini-course/share-link'
import EmbedStep from 'src/pages/create-mini-course/embed'
import { ButtonType, ButtonData, ButtonActionType } from 'src/model/button'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import NamingModal from 'src/components/naming-modal'
import { courseCloneAction } from 'src/reducers/collection/action'
import { courseDeleteAction } from 'src/reducers/collection/action'
import { getCollectionCourseList } from 'src/reducers/collection/action'
import { courseReportAction } from 'src/reducers/course/action'
import { patchCourseLandingPageAction } from 'src/reducers/course/action' // Yeni import
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import { track } from '@amplitude/analytics-browser'
import LimitReachedModal from 'src/components/limit-reached-modal'
import { useHistory } from 'react-router-dom'

import { MoveTo } from './components'
import {
  getCoursePreviewTokenService,
  publishCourseService,
  unpublishCourseService,
} from 'src/api/course'
// ----------------------------------------------------------------------

import URL from 'src/api/url'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import EditCard from '../editor/components/custom-plugins/simple-box/course-list/edit-card'

CourseToolBar.propTypes = {
  course: PropTypes.object,
  index: PropTypes.number,
  onDeleteTask: PropTypes.func,
}

/**
 * `renderTrigger` replaces the default analytics + menu buttons; it gets
 * `{ openMenu, openAnalytics }`.
 */
export default function CourseToolBar({
  course,
  setLocalCourses,
  localCourses,
  classes,
  renderTrigger,
}) {
  const dispatch = useDispatch()
  const history = useHistory()
  const renameRef = useRef(null)
  const [isNamingModalOpen, setNamingModalOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [courseUpdateData, setCourseUpdateData] = useState(null) // Yeni state

  const [toolBarOpen, setToolBarOpen] = useState(null)
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (toolBarOpen) {
      if (renameRef.current) {
        renameRef.current.focus()
      }
    }
  }, [toolBarOpen])

  const handleOpen = event => {
    setToolBarOpen(event.currentTarget)
  }

  const handleClose = () => {
    setToolBarOpen(null)
  }

  const duplicateCourse = course => {
    dispatch(
      courseCloneAction(course.code, response => {
        track('course_duplicate_clicked')
        handleClose()
        let stateValue = [response, ...localCourses]
        setLocalCourses(stateValue)
      }),
    )
  }

  const editCourse = () => {
    dispatch(courseGetSuccess(null))
    dispatch(clearCardState())
    history.push('/mini-course/' + course.id + '/page')
  }

  const previewCourse = async course => {
    handleClose()

    // Opened synchronously, before the token request: awaiting first would take window.open out of
    // the click's user gesture and popup blockers would kill it. `noopener` is not passed as a
    // feature because that makes window.open return null, leaving nothing to navigate — the opener
    // is severed by hand instead, which is the same guarantee.
    const target = window.open('', '_blank')

    if (target) {
      target.opener = null
    }

    let targetUrl = URL.APP_URL + course.code

    // A draft course is not reachable on the learner origin, which has no admin session — the right
    // to see it has to travel in the URL. Published courses need nothing extra.
    if (course.isPublished === false) {
      try {
        const response = await getCoursePreviewTokenService(course.id)
        // Same { data, statusCode } envelope the rest of the API uses.
        const token = (response?.data ?? response)?.token

        if (token) {
          targetUrl += `?previewToken=${encodeURIComponent(token)}`
        }
      } catch (error) {
        // Fall through to the bare URL: the learner app will say the course was not found, which
        // is the behaviour this had before tokens existed.
      }
    }

    if (target) {
      target.location = targetUrl
    } else {
      window.open(targetUrl, '_blank', 'noopener,noreferrer')
    }
  }

  const shareLinkCourse = course => {
    track('Course_Share', {
      type: 'Link',
    })
    handleClose()
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Share Link',
          component: <ShareLinkStep dispatch={dispatch} entity={course} />,
          hideCloseButton: false,
        }),
      ),
    )
  }

  const shareEmbedCourse = course => {
    track('Course_Share', {
      type: 'Embed',
    })
    handleClose()

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Share Embed',
          component: <EmbedStep dispatch={dispatch} entity={course} />,
        }),
      ),
    )
  }

  // Yeni fonksiyon: Change Thumbnail için
  const changeThumbnailCourse = course => {
    track('course_change_thumbnail_clicked')
    handleClose()
    // Temporary state to store current modal values
    let currentModalData = {
      thumbnail: course.thumbnail || '',
      description: course.description || '',
    }

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => {
                dispatch(messageBoxHideAction())
                setCourseUpdateData(null)
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Save',
              ButtonActionType.YES,
              () => {
                dispatch(
                  patchCourseLandingPageAction(course.id, [
                    {
                      path: 'thumbnail',
                      value: currentModalData.thumbnail,
                    },
                    {
                      path: 'description',
                      value: currentModalData.description,
                    },
                  ]),
                )

                const courseIndex = localCourses.findIndex(
                  c => c.id === Number(course.id),
                )
                if (courseIndex !== -1) {
                  const updatedCourses = [...localCourses]
                  updatedCourses[courseIndex] = {
                    ...updatedCourses[courseIndex],
                    thumbnail: currentModalData.thumbnail,
                    description: currentModalData.description,
                  }
                  setLocalCourses(updatedCourses)
                }

                dispatch(messageBoxHideAction())
                setCourseUpdateData(null)
              },
            ),
          ],
          title: 'Change thumbnail',
          component: (
            <EditCard
              thumbnailUrl={course.thumbnail || ''}
              description={course.description || ''}
              onSave={settings => {
                currentModalData = { ...settings }
                setCourseUpdateData({
                  id: course.id,
                  landingPageSettings: settings,
                })
              }}
              setImageURL={() => {}}
            />
          ),
          maxWidth: '680px',
        }),
      ),
    )
  }

  const deleteCourse = course => {
    handleClose()
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              translator._('action.no'),
              ButtonActionType.NO,
              () => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              translator._('action.yes'),
              ButtonActionType.DELETE,
              () => {
                dispatch(
                  courseDeleteAction(course.id, () => {
                    dispatch(messageBoxHideAction())
                    track('course_deleted')
                    setLocalCourses(
                      localCourses.filter(c => c.id !== course.id),
                    )
                  }),
                )
              },
            ),
          ],
          title: 'Deleting Course',
          subTitle: null,
          description: translator._('message.delete'),
          variant: MessageBoxVariant.NOTICE,
        }),
      ),
    )
  }

  // Publishing from the collection means a user never has to open the editor just to put a
  // course live. Moving back to draft is the outward-facing one, so only it asks for
  // confirmation.
  const handlePublish = async course => {
    handleClose()

    try {
      await publishCourseService(course.id)
      updatePublishState(course.id, true)
      track('course_published')
      enqueueSnackbar(`"${course.name}" is now live for learners.`, {
        variant: 'success',
      })
    } catch (error) {
      enqueueSnackbar('Could not publish this course.', {
        variant: 'error',
      })
    }
  }

  const handleUnpublish = course => {
    handleClose()

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Move to draft',
              ButtonActionType.DELETE,
              async () => {
                try {
                  await unpublishCourseService(course.id)
                  updatePublishState(course.id, false)
                  track('course_unpublished')
                  enqueueSnackbar(
                    `"${course.name}" moved to draft. Learners no longer see it.`,
                    {
                      variant: 'success',
                    },
                  )
                } catch (error) {
                  enqueueSnackbar('Could not move this course to draft.', {
                    variant: 'error',
                  })
                } finally {
                  dispatch(messageBoxHideAction())
                }
              },
            ),
          ],
          title: 'Move this course back to draft?',
          subTitle: null,
          description:
            'Learners lose access right away and the share link stops working. Content and learner progress are kept, so you can publish it again later.',
          // Without a cap the box is fit-content, so this description sets the width and the modal
          // stretches into one very wide line. 500px is what the other text confirmations use.
          maxWidth: '500px',
          variant: MessageBoxVariant.NOTICE,
        }),
      ),
    )
  }

  const updatePublishState = (courseId, isPublished) => {
    // The local update below only reaches this grid. Every other view of the collection — the
    // landing page and its preview above all — reads the course list from redux, and nothing else
    // refetches it when switching tabs, so without this a course just published stays absent from
    // its own landing page until something remounts.
    if (course?.courseCollectionId) {
      dispatch(getCollectionCourseList(course.courseCollectionId, () => {}))
    }

    if (!setLocalCourses || !localCourses) {
      return
    }

    setLocalCourses(
      localCourses.map(c =>
        c.id === courseId ? { ...c, isPublished } : c,
      ),
    )
  }

  const handleGetAnalytics = course => {
    track('course_analytics_clicked')
    dispatch(courseReportAction(course.id))
  }

  const handleTransportClick = course => {
    handleClose()
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Select learning path',
          component: (
            <MoveTo
              course={course}
              setLocalCourses={setLocalCourses}
              localCourses={localCourses}
            />
          ),
        }),
      ),
    )
  }

  return (
    <>
      {renderTrigger ? (
        renderTrigger({
          openMenu: handleOpen,
          openAnalytics: () => handleGetAnalytics(course),
        })
      ) : (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={0.5}
      >
        <Tooltip title="Analytics">
          <CoreIconButton
            size="small"
            color="secondary"
            variant="text"
            onClick={() => {
              handleGetAnalytics(course)
            }}
          >
            <Icon icon={'uim:analytics'} />
          </CoreIconButton>
        </Tooltip>
        <CoreIconButton
          size="small"
          color="secondary"
          variant="text"
          onClick={handleOpen}
        >
          <Icon icon={'eva:more-vertical-fill'} />
        </CoreIconButton>
      </Stack>
      )}

      <MenuPopover
        open={Boolean(toolBarOpen)}
        anchorEl={toolBarOpen}
        onClose={handleClose}
        sx={{
          width: 'auto',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
        disabledArrow
      >
        {course.isPublished ? (
          <MenuItem
            onClick={() => {
              handleUnpublish(course)
            }}
          >
            <Icon
              icon="mdi:eye-off-outline"
              width={18}
              height={18}
              style={{ marginRight: 8, color: '#637381' }}
            />
            Move to draft
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => {
              handlePublish(course)
            }}
          >
            <Icon
              icon="mdi:tray-arrow-up"
              width={18}
              height={18}
              style={{ marginRight: 8, color: '#637381' }}
            />
            Publish
          </MenuItem>
        )}
        <Divider sx={{ my: 0.5 }} />
        <MenuItem
          onClick={() => {
            editCourse(course)
          }}
        >
          <Icon
            icon="mdi:pencil-outline"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          {translator._('courseCollection.course.edit')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            previewCourse(course)
          }}
        >
          <Icon
            icon="mdi:eye-outline"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            duplicateCourse(course)
          }}
        >
          <Icon
            icon="mdi:content-copy"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          {translator._('courseCollection.course.duplicate')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            shareLinkCourse(course)
          }}
        >
          <Icon
            icon="mdi:link-variant"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          Share Link
        </MenuItem>
        <MenuItem
          onClick={() => {
            shareEmbedCourse(course)
          }}
        >
          <Icon
            icon="mdi:code-tags"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          Embed
        </MenuItem>

        <MenuItem
          onClick={() => {
            changeThumbnailCourse(course)
          }}
        >
          <Icon
            icon="mdi:image-outline"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          Change thumbnail
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleTransportClick(course)
          }}
        >
          <Icon
            icon="mdi:folder-move-outline"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#637381' }}
          />
          Move to
        </MenuItem>
        <MenuItem
          onClick={() => {
            deleteCourse(course)
          }}
          style={{ color: '#d4351c' }}
        >
          <Icon
            icon="mdi:trash-can-outline"
            width={18}
            height={18}
            style={{ marginRight: 8, color: '#d4351c' }}
          />
          {translator._('courseCollection.course.delete')}
        </MenuItem>
      </MenuPopover>
      {isNamingModalOpen && (
        <NamingModal
          classes={classes}
          dispatch={dispatch}
          courseEntity={course}
        />
      )}
      {modalOpen && (
        <LimitReachedModal
          classes={classes}
          handleCloseModal={() => setModalOpen(false)}
          isModalOpen={modalOpen}
          history={history}
        />
      )}
    </>
  )
}
